import styled from "styled-components";
import { bgDiagonalLines } from "assets/images";

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 4px;
`;
export const SectionTitle = styled.h2`
  color: #000;
  font-family: "Aeonik", sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px;
  margin-bottom: 0;
`;
export const SectionDescription = styled.p`
  color: #535862;
  font-family: "Geist", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  margin-bottom: 20px;
`;

export const SectionContainer = styled.div`
  width: 100%;
  padding: 3rem 1rem;
  margin: 1.5rem 0;
  position: relative;
  border-top: 1px solid #f5f5f5;
  border-bottom: 1px solid #f5f5f5;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url(${bgDiagonalLines}),
      linear-gradient(
        135deg,
        rgba(255, 255, 255, 0.95) 0%,
        rgba(255, 255, 255, 0.85) 100%
      );
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    z-index: 1;
  }

  > * {
    position: relative;
    z-index: 2; /* Increased z-index to ensure cards are above background */
  }

  @media (max-width: 768px) {
    padding: 1.5rem 0.5rem;
    margin: 1rem 0;
  }
`;

export const CardsGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;

  > div {
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }
  }

  .loading-card {
    background: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    padding: 2rem;
    text-align: center;
    color: #6c757d;
    font-family: "Geist", sans-serif;
    font-size: 14px;
    min-height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    min-width: 250px;
  }

  .no-data {
    color: #6c757d;
    font-family: "Geist", sans-serif;
    font-size: 16px;
    text-align: center;
    padding: 2rem;
    margin: 0;
  }
`;
